import React from 'react';

interface CollapsiblePanelProps {
  isOpen: boolean;
  children: React.ReactNode;
  durationMs?: number;
}

/**
 * CollapsiblePanel
 *
 * Animated height-collapse wrapper controlled by `isOpen`.
 * Uses CSS grid row animation for smooth, consistent transitions
 * without needing to measure scrollHeight.
 */
export function CollapsiblePanel({ isOpen, children, durationMs = 300 }: CollapsiblePanelProps) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateRows: isOpen ? '1fr' : '0fr',
        transition: `grid-template-rows ${durationMs}ms ease-in-out`,
      }}
    >
      <div style={{ overflow: 'hidden' }}>
        {children}
      </div>
    </div>
  );
}
